import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: (rowData: any) => {
					const { deployedAt, deployedBy } = rowData;
					if (deployedAt || deployedBy) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateWebsiteUpdateInfo,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addWebsiteUpdateInfo,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Deploy on Website',
				id: 'deploy',
				isEnabled: (rowData: any) => {
					const { deployedAt, deployedBy } = rowData;
					if (deployedAt || deployedBy) {
						return false;
					}

					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo]?.deployWebsiteUpdate,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.apkUpdateInfo,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo]?.addWebsiteUpdateInfo,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
